import { Link } from "react-router-dom";
import { articles } from "@/mocks/mangaData";
import ArticleCard from "./ArticleCard";

export default function LatestUpdates() {
  const featured = articles.filter((a) => a.featured);
  const rest = articles.filter((a) => !a.featured);
  const hero = featured[0];
  const side = featured.slice(1, 3);
  const list = rest.slice(0, 4);

  return (
    <section id="latest-updates" className="mx-auto max-w-7xl scroll-mt-20 px-4 py-14 md:px-6" aria-labelledby="latest-heading">
      <div className="flex flex-col items-start justify-between gap-3 sm:flex-row sm:items-end">
        <div>
          <h2 id="latest-heading" className="font-heading text-2xl text-foreground-950 md:text-3xl">
            最新话 · 热更速览
          </h2>
          <p className="mt-2 text-sm text-foreground-600">今日人气连载的最新更新，点开即读。</p>
        </div>
        <Link
          to="/category/latest"
          className="inline-flex whitespace-nowrap items-center gap-1 text-sm text-primary-600 transition-colors hover:text-primary-700"
        >
          更多最新话 <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="mt-6 grid grid-cols-1 gap-5 lg:grid-cols-2">
        {hero && (
          <Link
            to={`/article/${hero.id}`}
            className="group relative flex min-h-[340px] flex-col justify-end overflow-hidden rounded-lg p-6 md:p-8"
          >
            <img
              src={hero.cover}
              alt={hero.title}
              className="absolute inset-0 h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/40 to-black/10" />
            <div className="relative z-10">
              <span className="inline-flex items-center gap-1 rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-white">
                <i className="ri-flashlight-fill" /> 精选热更
              </span>
              <h3 className="mt-3 text-xl font-semibold leading-snug text-white md:text-2xl">{hero.title}</h3>
              <p className="mt-2 line-clamp-2 text-sm text-white/80">{hero.excerpt}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-white">
                立即阅读 <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
              </span>
            </div>
          </Link>
        )}

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
          {side.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
          {list.slice(0, 2).map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      </div>

      <div className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {list.slice(2, 6).map((article) => (
          <ArticleCard key={article.id} article={article} />
        ))}
      </div>
    </section>
  );
}